import axios, { AxiosResponse } from 'axios';

interface ILeiData {
    lei: string;
    ic: string;
    spolecnost: string;
    stav: string;
    stat: string;
    lou: string;
    forma?: string;
}

const checkLeiApi = (lei: string) => {
    return axios({
        method: 'GET',
        url: `ISIN/LEI?lei=${lei}`
    }).then((resp: AxiosResponse<ILeiData>) => resp.data);
};

export default checkLeiApi;
